import VueRouter, { RouteConfig } from 'vue-router';
import { VueConstructor } from 'vue';

export default class RouterManager {
  private router: VueRouter;
  private parent: VueConstructor;

  constructor(router: VueRouter, parent: VueConstructor) {
    this.router = router;
    this.parent = parent;
  }

  public addRoutes(routes: RouteConfig[]) {
    const route: RouteConfig = {
      path: '/main',
      component: this.parent,
      children: routes,
    };

    this.router.addRoutes([route]);
  }
}
